import {
  SignInEmailRequest,
  SignInState,
} from "../../shared/interfaces/components/signin.interface";
import * as types from "./consts";

export const getEmailSignInRequest = (payload: SignInEmailRequest) => ({
  type: types.GET_SIGNIN_EMAIL_REQUEST,
  payload
});

export const firebaseInitiateRequest = (payload: SignInState) => ({
  type: types.FIREBASE_SIGNIN_PWD_REQUEST,
  payload,
});

export const getAllProductsRequest = (payload: SignInState) => ({
  type: types.GET_ALL_PRODUCTS_REQUEST,
  payload,
});
